import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { eventBus, getMarginBottomClass, Link, IconChevronRightThick, Reveal, marginBottomLevels } from '@piggybank/core';
import omit from 'lodash/fp/omit';
import kebabCase from 'lodash/fp/kebabCase';
import styles from './doorhanger.css.js';

var DoorHanger = /*#__PURE__*/function (_Component) {
  _inherits(DoorHanger, _Component);

  function DoorHanger(props) {
    var _this;

    _classCallCheck(this, DoorHanger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DoorHanger).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (event) {
      event.preventDefault();
      eventBus.dispatch({
        type: _this.state.expanded ? 'onClose' : 'onOpen',
        component: 'DoorHanger'
      });

      _this.setState({
        expanded: !_this.state.expanded
      });

      if (_this.props.onClose && _this.state.expanded) {
        _this.props.onClose(event);
      }

      if (_this.props.onOpen && !_this.state.expanded) {
        _this.props.onOpen(event);
      }
    });

    _this.id = props.id || kebabCase(props.title);
    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(DoorHanger, [{
    key: "render",
    value: function render() {
      var _omit = omit(['onOpen', 'OnClose'], this.props),
          children = _omit.children,
          title = _omit.title,
          marginBottom = _omit.marginBottom,
          rest = _objectWithoutProperties(_omit, ["children", "title", "marginBottom"]);

      return React.createElement("div", _extends({
        id: this.id,
        className: cn(getMarginBottomClass(marginBottom))
      }, rest), React.createElement(Link, {
        elementType: "button",
        type: "button",
        strong: true,
        hoverUnderline: true,
        iconSlotLeft: React.createElement("span", {
          className: cn(styles.icon, _defineProperty({}, styles.iconOpen, this.state.expanded))
        }, React.createElement(IconChevronRightThick, {
          inline: true
        })),
        onClick: this.handleToggle,
        "aria-expanded": this.state.expanded,
        "aria-controls": "".concat(this.id, "-expander"),
        buttonPadding: true
      }, title), React.createElement(Reveal, {
        id: "".concat(this.id, "-expander")
      }, this.state.expanded && React.createElement("div", {
        className: styles.accentBar
      }, children)));
    }
  }]);

  return DoorHanger;
}(Component);

_defineProperty(DoorHanger, "defaultProps", {
  marginBottom: 0
});

DoorHanger.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * proxied to eventBus
   */
  onOpen: PropTypes.func,

  /**
   * proxied to eventBus
   */
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
export default DoorHanger;